/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';

import * as S from './style';

export const LeftContainer = ({ children, ...rest }) => {
  return (
    <S.ColContainer md={7} xs={12}>
      {children}
    </S.ColContainer>
  );
};
